import React from 'react'
import { addNotifications } from '../../../toaster/ToasterPortalSlice'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setUploadedFile } from '../../manageusers/ManageUserSlice'
import { getTemplate, uploadSheet } from '../../manageusers/ManageUserSaga'
import FileUpload from '../../../../components/fileupload/FileUpload';
import Button from '../../../../components/button/Button'
import styles from './ImportUsers.styles'
import Loadable from '../../../../components/loadable/Loadable'
import { USER_LOADING_STATES, USER_MESSAGE_MAP } from '../../constant'

export default function ImportUsers() {

    const { uploadedFile, loadingState } = useSelector((state) => state[componentKey]);
    const dispatch = useDispatch();

    const allowedFileTypes = ['.xlsx', '.csv', '.xls'];

    const handleUploadedFileChange = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (allowedFileTypes.includes(`.${fileExtension}`)) {
            if (file) {
                dispatch(setUploadedFile(file));
            }
        } else {
            dispatch(addNotifications({ heading: "File format not supported", message: "Invalid file format. Please upload a .xlsx or .csv file." }));
        }
        event.target.value = null;
    };

    const handleFileUpload = () => {
        dispatch(uploadSheet(uploadedFile))
    }

    const handleDrop = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        
        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (allowedFileTypes.includes(`.${fileExtension}`)) {
            dispatch(setUploadedFile(file));
            if (file) {
                dispatch(uploadSheet(file));
            }
        } else {
            dispatch(addNotifications({ heading: "File format not supported", message: "Invalid file format. Please upload a .xlsx or .csv file." }));
        }
    };
    return (
        <div style={styles.mainContainer}>
            <Loadable currentState={loadingState.state} loadingStates={[USER_LOADING_STATES.IMPORT_LOADING]} messageMap={USER_MESSAGE_MAP} isNewLoadable={true}>
                <FileUpload
                    uploadedFile={uploadedFile}
                    onDropCb={handleDrop}
                    templatesForDownload={[
                        {
                            templateText: "Download Template",
                            downloadTemplateCb: () => dispatch(getTemplate()),
                        },
                    ]}
                    onInputChangeCb={handleUploadedFileChange}
                />
            </Loadable>

            {uploadedFile && 
                <div style={styles.actionButton}>
                    <Button onClickCb={handleFileUpload}>Next</Button>
                </div>
            }
        </div>
    )
}